export default {
    data() {
        return {
            mixinHoverColor: "var(--v-primary-base)",
            mixinHoverOpacity: 0.2,
            mixinCheckedColor: "green",
            mixinCheckedOpacity: 0.2,
        };
    },
    methods: {
        decodeHtml(html) {
            var txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        },
    },
    mounted() {
        window.clickOnElement = function (id) {
            this.$emit("clicked-on-element", id.substring(1));
        }.bind(this);

        window.showToolTip = function (text, event) {
            const tooltip = this.$el.querySelector(".tooltip");
            tooltip.innerText = this.decodeHtml(text);
            tooltip.style.top = event.offsetY - 50 + "px";
            if(event.offsetX < 400) {
                tooltip.style.left = event.offsetX + "px";
            }
            tooltip.style.opacity = 1;
            tooltip.style.zIndex = 1000;
            this.$emit("tooltip-name", text);
        }.bind(this);

        window.hideToolTip = function () {
            const tooltip = this.$el.querySelector(".tooltip");
            tooltip.innerText = "";
            tooltip.style.opacity = 0;

            // lol
            tooltip.style.top = 3000;
            tooltip.style.left = 3000;
            // lol
        }.bind(this);

        // methods called in the xml returned even though we don't need them
        window.setPathStyle = function (event, color) {}.bind(this);
        window.resetPathStyle = function (event) {}.bind(this);
    },
    beforeDestroy() {
        delete window.clickOnElement;
        delete window.showToolTip;
        delete window.hideToolTip;
        delete window.setPathStyle;
        delete window.resetPathStyle;
    },
};
